import React, { useState, useEffect } from "react";
import axios from "axios";
// import Navbar from "./NavBar";
import CustomNavbar from "./CustomPermissions/CustomNavbar";

import { useRef } from "react"; // Import useRef

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../config/api";

const ClosingReportPage = () => {
  const [companies, setCompanies] = useState([]);
  const [activeCompany, setActiveCompany] = useState(null);
  const [activeDepartment, setActiveDepartment] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [expandedRow, setExpandedRow] = useState(null);

  const [formDetails, setFormDetails] = useState({
    CompanyName: "",
    docs: null,
    formonth: "",
    year: "",
    revenue: "",
    expense: "",
    dept: "",
    collection: "",
    profit: "",
    salary_sheet: null,
    extra: "",
  });

  const [departments, setDepartments] = useState([]);
  const [editId, setEditId] = useState(null);

  const lastSelected = useRef({ company: null, department: null });

  useEffect(() => {
    fetchCompanies();
    fetchDepartments();
  }, []);

  const dynamicFieldConfig = {
    "Docladder Digital": {
      Operations: [
        { name: "collection", label: "Client" },
        { name: "revenue", label: "Revenue" },
      ],

      Finance: [
        { name: "collection", label: "Collection" },
        { name: "revenue", label: "Next Month Proposed Collection" },
        { name: "expense", label: "Expense" },
        { name: "profit", label: "Profit" },
        { name: "extra", label: "Bank Balance" },
      ],
      Marketing: [
        { name: "collection", label: "Client Onboard" },
        { name: "revenue", label: "Revenue" },
        { name: "profit", label: "Advance Amount" },
      ],
      Tech: [
        { name: "collection", label: "Module Completed" },
        { name: "revenue", label: "Department" },
        { name: "extra", label: "Module Working" },
        { name: "expense", label: "Deadline" },
        { name: "profit", label: "Completion" },
      ],

      HR: [
        { name: "collection", label: "Vacancy" },
        { name: "revenue", label: "On-boarded" },
        { name: "expense", label: "Salary" },
        { name: "profit", label: "Next Month Expected Salary" },
        { name: "salary_sheet", label: "Salary Sheet" },
      ],
      Assets: [
        { name: "collection", label: "Assets" },
        { name: "revenue", label: "Type" },
        { name: "expense", label: "Problem" },
        { name: "profit", label: "Quantity" },
      ],
    },
    "Docladder Pvt Ltd": {
      Operations: [
        { name: "collection", label: "Closures" },
        { name: "revenue", label: "Revenue" },
        { name: "expense", label: "S Revenue" },
        { name: "profit", label: "SS Revenue" },
        { name: "extra", label: "Docladder Closures" },
      ],
      Finance: [
        { name: "collection", label: "Collection" },
        { name: "revenue", label: "Next Month Proposed Collection" },
        { name: "expense", label: "Expense" },
        { name: "profit", label: "Profit" },
        { name: "extra", label: "Bank Balance" },
      ],
      Marketing: [
        { name: "collection", label: "Client Onboard" },
        { name: "revenue", label: "Revenue" },
        { name: "profit", label: "Advance Amount" },
      ],
      Tech: [
        { name: "collection", label: "Module Completed" },
        { name: "revenue", label: "Department" },
        { name: "extra", label: "Module Working" },
        { name: "expense", label: "Deadline" },
        { name: "profit", label: "Completion" },
      ],
      HR: [
        { name: "collection", label: "Vacancy" },
        { name: "revenue", label: "On-boarded" },
        { name: "expense", label: "Salary" },
        { name: "profit", label: "Next Month Expected Salary" },
        { name: "salary_sheet", label: "Salary Sheet" },
      ],
      Assets: [
        { name: "collection", label: "Assets" },
        { name: "revenue", label: "Type" },
        { name: "expense", label: "Problem" },
        { name: "profit", label: "Quantity" },
      ],
    },
    Pace: {
      Operations: [
        { name: "collection", label: "Closures" },
        { name: "revenue", label: "Revenue" },
        { name: "expense", label: "S Revenue" },
        { name: "profit", label: "SS Revenue" },
      ],
      Finance: [
        { name: "collection", label: "Collection" },
        { name: "revenue", label: "Next Month Proposed Collection" },
        { name: "expense", label: "Expense" },
        { name: "profit", label: "Profit" },
        { name: "extra", label: "Bank Balance" },
      ],
      Marketing: [
        { name: "collection", label: "Client Onboard" },
        { name: "revenue", label: "Revenue" },
        { name: "profit", label: "Advance Amount" },
      ],
      Tech: [
        { name: "collection", label: "Module Completed" },
        { name: "revenue", label: "Department" },
        { name: "extra", label: "Module Working" },
        { name: "expense", label: "Deadline" },
        { name: "profit", label: "Completion" },
      ],
      HR: [
        { name: "collection", label: "Vacancy" },
        { name: "revenue", label: "On-boarded" },
        { name: "expense", label: "Salary" },
        { name: "profit", label: "Next Month Expected Salary" },
        { name: "salary_sheet", label: "Salary Sheet" },
      ],
      Assets: [
        { name: "collection", label: "Assets" },
        { name: "revenue", label: "Type" },
        { name: "expense", label: "Problem" },
        { name: "profit", label: "Quantity" },
      ],
    },
  };

  const fetchCompanies = async () => {
    try {
      const response = await axios.get(
        getApiUrl("/hierarchical-closing-reports/"),
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const sortedCompanies = response.data.map((company) => {
        if (company.company_name === "Pace") {
          company.departments.forEach((department) => {});
        }

        company.departments.forEach((department) => {
          department.reports.sort(
            (a, b) => b.year - a.year || b.formonth - a.formonth // Sort by year and month
          );
        });

        const latestReport = company.departments
          .flatMap((dept) => dept.reports)
          .sort((a, b) => b.year - a.year || b.formonth - a.formonth)[0];

        company.latestReport = latestReport; // Attach the latest report to the company

        return company;
      });

      // Sort companies by their latest report date
      sortedCompanies.sort((a, b) => {
        const aDate = a.latestReport
          ? new Date(a.latestReport.year, a.latestReport.formonth - 1)
          : new Date(0); // Default to the earliest date if no reports
        const bDate = b.latestReport
          ? new Date(b.latestReport.year, b.latestReport.formonth - 1)
          : new Date(0);

        return bDate - aDate; // Sort descending by date
      });

      setCompanies(sortedCompanies);
      // Restore last selected company and department if available
      if (lastSelected.current.company && lastSelected.current.department) {
        setActiveCompany(lastSelected.current.company);
        setActiveDepartment(lastSelected.current.department);
      } else if (sortedCompanies.length > 0) {
        // Default to the first company and department on reload
        setActiveCompany(sortedCompanies[0]?.company_id);
        setActiveDepartment(sortedCompanies[0]?.departments[0]?.department_id);
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  const fetchDepartments = async () => {
    try {
      const response = await axios.get(getApiUrl("/departments/"), {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      });
      setDepartments(response.data);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  const getActiveCompanyData = () =>
    companies.find((company) => company.company_id === activeCompany);

  const getActiveDepartmentReports = () =>
    getActiveCompanyData()?.departments.find(
      (dept) => dept.department_id === activeDepartment
    );
  const getDynamicFields = () => {
    const companyName = getActiveCompanyData()?.company_name;
    const departmentName = getActiveDepartmentReports()?.department_name;

    if (dynamicFieldConfig[companyName]?.[departmentName]) {
      return dynamicFieldConfig[companyName][departmentName];
    }
    return [];
  };

  const openModal = (report = null) => {
    const dynamicFields = getDynamicFields();

    // Initialize dynamic fields
    const initialDynamicFields = dynamicFields.reduce((acc, { name }) => {
      acc[name] = report ? report[name] || "" : ""; // Use report values or empty
      return acc;
    }, {});

    setFormDetails({
      CompanyName: activeCompany,
      docs: null,
      // salary_sheet: null,
      formonth: report?.formonth || "",
      year: report?.year || "",
      dept: activeDepartment,
      ...initialDynamicFields, // Add dynamic fields to the form details
    });

    setEditId(report ? report.id : null);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setFormDetails({
      CompanyName: "",
      docs: null,
      formonth: "",
      year: "",
      revenue: "",
      expense: "",
      dept: "",
      collection: "",
      profit: "",
      salary_sheet: null,
      extra: "",
    });
    setEditId(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    Object.entries(formDetails).forEach(([key, value]) => {
      if (value) formData.append(key, value);
    });

    const url = editId
      ? getApiUrl(`/closing-reports/${editId}/`)
      : getApiUrl("/closing-reports/");
    const method = editId ? "put" : "post";

    try {
      // Save the current active company and department
      lastSelected.current = {
        company: activeCompany,
        department: activeDepartment,
      };
      await axios({
        method,
        url,
        data: formData,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "multipart/form-data",
        },
      });
      fetchCompanies();
      setActiveCompany(lastSelected.current.company);
      setActiveDepartment(lastSelected.current.department);
      closeModal();
    } catch (error) {
      console.error("Error saving report:", error);
    }
  };

  const renderDynamicPlaceholders = (departmentName) => {
    switch (departmentName) {
      case "Tech":
        return {
          collection: "Modules Completed",
          revenue: "Department",
          extra: "Modules Working",
          expense: "Deadline",
          profit: "Completion",
          // salary_sheet: "Salary Sheet",
        };

      case "Marketing":
        return {
          collection: "Client Onboard",
          revenue: "Revenue",
          profit: "Advance Amount",
          // salary_sheet: "Salary Sheet",
        };
      case "HR":
        return {
          collection: "Vacancy",
          revenue: "Onboarded",
          expense: "Salary",
          profit: "Next Month Expected Salary",
          salary_sheet: "Salary Sheet",
        };
      case "Finance":
        return {
          collection: "Collection",
          revenue: "Next Month Proposed",
          expense: "Expenses",
          profit: "Profit",
          extra: "Bank Balance",
          // salary_sheet: "Salary Sheet",
        };
      case "Assets":
        return {
          collection: "Assets",
          revenue: "Type",
          expense: "Problem",
          profit: "Quantity",
          // salary_sheet: "Salary Sheet",
        };
      default:
        return {
          collection: "Collection",
          revenue: "Revenue",
          expense: "Expense",
          profit: "Profit",
          // salary_sheet: "Salary Sheet",
        };
    }
  };

  const placeholders = renderDynamicPlaceholders(
    getActiveDepartmentReports()?.department_name
  );

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [reportToDelete, setReportToDelete] = useState(null);

  const openDeleteModal = (report) => {
    setReportToDelete(report);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setReportToDelete(null);
  };

  const handleDelete = async () => {
    if (reportToDelete) {
      try {
        const response = await fetch(
          getApiUrl(`/closing-reports/${reportToDelete.id}/`),
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );

        if (response.ok) {
          alert("Report deleted successfully!");
          fetchCompanies();
          // Optionally, refresh data or remove the report from the state
        } else {
          alert("Failed to delete the report.");
        }
      } catch (error) {
        alert("An error occurred. Please try again.");
      } finally {
        closeDeleteModal();
      }
    }
  };

  return (
    <>
      <div style={{ display: "flex" }}>
        <CustomNavbar />

        <div
          className="flex min-h-screen "
          style={{
            width: "100%",
            background: "#F9FAFB",
            backgroundSize: "100% 100%",
          }}
        >
          {/* Left Sidebar */}
          <div className="w-1/4 bg-white shadow-md">
            <h2 className="text-xl font-bold p-4 border-b text-blue-700">
              Companies
            </h2>
            <ul className="space-y-1 p-4">
              {companies
                .slice() // Create a shallow copy to avoid mutating the original array
                .sort((a, b) => a.company_name.localeCompare(b.company_name))
                .map((company) => (
                  <li
                    key={company.company_id}
                    onClick={() => setActiveCompany(company.company_id)}
                    className={`p-2 rounded-lg cursor-pointer font-medium ${
                      activeCompany === company.company_id
                        ? "bg-blue-500 text-white"
                        : "bg-gray-200 hover:bg-gray-300 text-gray-800"
                    }`}
                  >
                    {company.company_name}
                  </li>
                ))}
            </ul>
          </div>

          {/* Main Content */}
          <div className="flex-1 p-4">
            {getActiveCompanyData() ? (
              <>
                <h1 className="text-2xl font-bold mb-4 text-blue-700">
                  {getActiveCompanyData().company_name} - Departments
                </h1>

                {/* Department Buttons */}
                <div className="flex flex-wrap gap-2 mb-4">
                  {getActiveCompanyData()?.departments.map((department) => (
                    <button
                      key={department.department_id}
                      onClick={() =>
                        setActiveDepartment(department.department_id)
                      }
                      className={`px-3 py-1 rounded-lg font-medium ${
                        activeDepartment === department.department_id
                          ? "bg-blue-500 text-white"
                          : "bg-blue-200 hover:bg-blue-500 text-gray-800"
                      }`}
                    >
                      {department.department_name}
                    </button>
                  ))}
                </div>

                {/* Add Report Button */}
                <div className="mb-4">
                  <button
                    onClick={() => openModal()}
                    className="bg-blue-500 text-white px-4 py-2 rounded shadow hover:bg-blue-600 transition"
                  >
                    Add New Report
                  </button>
                </div>

                {/* Reports Section */}
                <div
                  className="bg-white p-4 rounded-lg shadow-md"
                  // style={{ minWidth: "70vw" }}
                >
                  {activeDepartment ? (
                    <>
                      <h2 className="text-xl font-bold mb-4 text-blue-700">
                        {getActiveDepartmentReports()?.department_name} Reports
                      </h2>
                      {getActiveDepartmentReports()?.reports.length > 0 ? (
                        <div className="overflow-x-auto w-full">
                          <table className="w-full bg-white border ">
                            <thead>
                              <tr
                                className="bg-blue-500 rounded-2xl"
                                style={{ fontSize: "16px" }}
                              >
                                <th className="border   text-center">#</th>
                                <th className="border px-1 py-1 text-center">
                                  Month
                                </th>
                                <th className="border px-1 py-1 text-center">
                                  Year
                                </th>
                                {getDynamicFields().map((field) => (
                                  <th
                                    key={field.name}
                                    className="border px-2 text-center"
                                  >
                                    {field.label}
                                  </th>
                                ))}
                                <th className="border px-1 py-1 text-center">
                                  Actions
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {getActiveDepartmentReports()?.reports.map(
                                (report, index) => (
                                  <tr
                                    key={report.id}
                                    className="hover:bg-gray-100 transition border"
                                    style={{ fontSize: "14px" }}
                                  >
                                    <td className="border px-4 py-2">
                                      {index + 1}
                                    </td>
                                    <td className="border px-4 py-2">
                                      {report.formonth}
                                    </td>
                                    <td className="border px-4 py-2">
                                      {report.year}
                                    </td>

                                    {getDynamicFields().map((field) => (
                                      <td
                                        key={field.name}
                                        className="border px-4 py-2"
                                      >
                                        {field.name === "salary_sheet" ? (
                                          <>
                                            {report[field.name] && (
                                              <a
                                                href={getApiUrl(`/media/${
                                                  report[field.name]
                                                }/`)}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-blue-700 hover:underline"
                                              >
                                                {report[field.name] ||
                                                  "No file"}
                                              </a>
                                            )}
                                          </>
                                        ) : (
                                          report[field.name] || ""
                                        )}
                                      </td>
                                    ))}

                                    <td className="px-4 py-2 flex mt-1">
                                      <a
                                        href={getApiUrl(`/media/${report.docs}/`)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-700 hover:underline"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          class="bi bi-eye"
                                          viewBox="0 0 16 16"
                                          style={{ marginRight: "15px" }}
                                        >
                                          <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                                          <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                                        </svg>
                                      </a>

                                      <button
                                        onClick={() => openModal(report)}
                                        className="text-yellow-500 px-2 py-1 rounded hover:bg-yellow-600 transition"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          class="bi bi-pencil-square"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                          <path
                                            fill-rule="evenodd"
                                            d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                                          />
                                        </svg>
                                      </button>
                                      <button
                                        onClick={() => openDeleteModal(report)}
                                        className="text-red-500 px-2 py-1 rounded hover:bg-red-600 transition ml-3"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          class="bi bi-trash-fill"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5m3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0" />
                                        </svg>
                                      </button>
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                            {isDeleteModalOpen && (
                              <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
                                <div className="bg-white p-6 rounded shadow-md">
                                  <h2 className="text-lg font-semibold">
                                    Confirm Deletion
                                  </h2>
                                  <p className="my-4">
                                    Are you sure you want to delete this report?
                                    This action cannot be undone.
                                  </p>
                                  <div className="flex justify-end space-x-4">
                                    <button
                                      onClick={closeDeleteModal}
                                      className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition"
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      onClick={handleDelete}
                                      className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
                                    >
                                      Delete
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </table>
                        </div>
                      ) : (
                        <p className="text-gray-500">
                          No reports available for this department.
                        </p>
                      )}
                    </>
                  ) : (
                    <p className="text-gray-500">
                      Select a department to view reports.
                    </p>
                  )}
                </div>
              </>
            ) : (
              <p className="text-gray-500">Loading companies...</p>
            )}
          </div>
        </div>

        {/* Modal */}
        {modalOpen && (
          // <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
          <div
            className="absolute inset-0 flex justify-center items-center z-50"
            id="marketingmodalopen"
            style={{ width: "100vw", height: "100vh" }}
          >
            <div
              className="absolute inset-0 bg-gray-800 bg-opacity-60 backdrop-blur-sm"
              style={{
                width: "100vw",
                height: "150%",
                background: "black",
                backgroundSize: "200% 200vh",
                overflowY: "hidden",
                paddingBottom: "150px",
              }}
            ></div>
            <div
              className="relative bg-white w-4/5 max-w-4xl rounded-lg shadow-lg"
              style={{
                // marginTop: "50px",
                height: "95vh", // Set height to allow scrolling
                overflowY: "auto", // Enable scrolling inside modal
              }}
            >
              <div
                className="overflow-auto max-h-[90vh]"
                style={{ padding: "100px", paddingTop: "20px" }}
              >
                <h2 className="text-lg font-bold mb-4">
                  {editId ? "Edit Report" : "Add Report"}
                </h2>
                <form
                  onSubmit={handleSubmit}
                  className="grid grid-cols-2 sm:grid-cols-1 gap-4"
                >
                  <select
                    name="CompanyName"
                    value={formDetails.CompanyName}
                    onChange={(e) =>
                      setFormDetails((prev) => ({
                        ...prev,
                        CompanyName: e.target.value,
                      }))
                    }
                    className="border p-2 rounded w-full"
                  >
                    <option value="">Select Company</option>
                    {companies.map((company) => (
                      <option
                        key={company.company_id}
                        value={company.company_id}
                      >
                        {company.company_name}
                      </option>
                    ))}
                  </select>

                  <select
                    name="formonth"
                    value={formDetails.formonth}
                    onChange={(e) =>
                      setFormDetails((prev) => ({
                        ...prev,
                        formonth: parseInt(e.target.value, 10),
                      }))
                    }
                    className="border p-2 rounded w-full"
                  >
                    <option value="">Select Month</option>
                    <option value="1">January</option>
                    <option value="2">February</option>
                    <option value="3">March</option>
                    <option value="4">April</option>
                    <option value="5">May</option>
                    <option value="6">June</option>
                    <option value="7">July</option>
                    <option value="8">August</option>
                    <option value="9">September</option>
                    <option value="10">October</option>
                    <option value="11">November</option>
                    <option value="12">December</option>
                  </select>

                  <select
                    name="dept"
                    value={formDetails.dept}
                    onChange={(e) =>
                      setFormDetails((prev) => ({
                        ...prev,
                        dept: e.target.value,
                      }))
                    }
                    className="border p-2 rounded w-full"
                  >
                    <option value="">Select Department</option>
                    {departments.map((dept) => (
                      <option key={dept.id} value={dept.id}>
                        {dept.name}
                      </option>
                    ))}
                  </select>

                  <input
                    type="number"
                    name="year"
                    value={formDetails.year}
                    onChange={(e) =>
                      setFormDetails((prev) => ({
                        ...prev,
                        year: e.target.value,
                      }))
                    }
                    placeholder="Year"
                    className="border p-2 rounded w-full"
                  />

                  <div>
                    <label className="block text-gray-700 mb-1">Report</label>
                    <input
                      type="file"
                      name="docs"
                      onChange={(e) =>
                        setFormDetails((prev) => ({
                          ...prev,
                          docs: e.target.files[0],
                        }))
                      }
                      className="border p-2 rounded w-full"
                    />
                  </div>

                  {/* <div>
                    <label className="block text-gray-700 mb-1">
                      Salary Sheet
                    </label>
                    <input
                      type="file"
                      name="salary_sheet"
                      onChange={(e) =>
                        setFormDetails((prev) => ({
                          ...prev,
                          salary_sheet: e.target.files[0],
                        }))
                      }
                      className="border p-2 rounded w-full"
                    />
                  </div> */}

                  {getDynamicFields().map(({ name, label }) => (
                    <div key={name} className="mb-4">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {label}
                      </label>
                      {name === "salary_sheet" ? (
                        // File Input for Salary Sheet
                        <input
                          type="file"
                          onChange={(e) =>
                            setFormDetails((prev) => ({
                              ...prev,
                              [name]: e.target.files[0],
                            }))
                          }
                          className="border p-2 rounded w-full"
                        />
                      ) : (
                        // Regular Text Input for Other Fields
                        <input
                          type="text"
                          value={formDetails[name] || ""}
                          onChange={(e) =>
                            setFormDetails((prev) => ({
                              ...prev,
                              [name]: e.target.value,
                            }))
                          }
                          placeholder={`Enter ${label}`}
                          className="border p-2 rounded w-full"
                        />
                      )}
                    </div>
                  ))}
                  <div className=" space-x-2">
                    <button
                      type="button"
                      onClick={closeModal}
                      className="bg-gray-500 text-white px-4 py-2 rounded"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="bg-blue-500 text-white px-4 py-2 rounded"
                    >
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ClosingReportPage;
